import InitComponent from 'Modules/InitComponent';
import LazyLoader from 'Modules/LazyLoader';

export default class InitLazyComponent extends InitComponent {
  constructor({ selectors, components, template, data = {}, store = null }) {
    super({ selectors, components, template, data, store });
  }

  init() {
    if (!this.selectors) {
      return;
    }

    this.selectorsAreIterable
      ? [...this.selectors].forEach((selector) =>
          LazyLoader.init(selector, this.singleInit)
        )
      : LazyLoader.init(this.selectors, this.singleInit);
  }
}
